import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { setTheme } from "@redux/slices/themeSlice";
import {
  extractBoxShadows,
  generateThemeTokens,
  generateTypographyTokens,
  regenerateTypographyTokens,
} from "@utils/design-tokens";
import { setTypography } from "@redux/slices/typographySlice";
import axios from "axios";
import {
  setIsCompanyTheme,
  setOrgTheme,
  setOrgTypography,
} from "@redux/slices/appStateSlice";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";

export const useThemeTokens = (
  url: string,
  enabled: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();
  return useQuery({
    queryKey: ["THEME_TOKENS"],
    cacheTime: 86400000,
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (data?.data?.global) {
          let theme = generateThemeTokens(
            data?.data?.global,
            data?.data?.global,
            {}
          );
          theme = extractBoxShadows(data?.data, theme);
          theme.updatedTime = new Date().toISOString();

          let typography: any = generateTypographyTokens(
            data?.data?.global,
            data?.data?.global,
            {}
          );

          typography = regenerateTypographyTokens(typography);
          typography.updatedTime = new Date().toISOString();

          if (type === ThemeTokenTypes.ORG) {
            dispatch(setOrgTheme(theme));
            dispatch(setOrgTypography(typography));
          }
          if (type === ThemeTokenTypes.COMPANY)
            dispatch(setIsCompanyTheme(true));
          dispatch(setTheme(theme));
          dispatch(setTypography(typography));
        }
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
